import styled from "styled-components";
import {
  Colors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;

  .description-wrapper {
    position: relative;
    margin-bottom: 5px;

    display: inline-flex;
    align-items: center;
    align-self: flex-start;

    cursor: pointer;

    &:hover {
      .arrow-icon-wrapper {
        color: ${SolutionColorVariables.sc1};
      }
    }
  }

  .trigger-description {
    padding: 0 4px 0 0;
    align-items: center;
    max-width: 252px;
    white-space: nowrap;
    overflow: hidden;

    &:hover {
      text-decoration: underline;
      text-underline-offset: 2px;

      svg {
        fill: ${SolutionColorVariables.sc1} !important;
      }
    }
  }

  .arrow-icon-wrapper {
    color: ${Colors.dGrey};
  }

  .action-description {
    margin-right: 4px;
    max-width: 250px;
    text-underline-offset: 2px;

    :hover:not(.disabled) {
      text-decoration: underline;

      svg {
        fill: ${SolutionColorVariables.sc1} !important;
      }
    }
    &.disabled:hover {
      color: ${Colors.dGrey} !important;
      cursor: default !important;
    }
  }
`;

export const StyledDotWrapper = styled.div<
  Partial<{
    open: boolean;
  }>
>`
  position: absolute;
  top: 11px;
  right: 11px;

  display: block;
  opacity: ${(props) => (props.open === true ? 1 : 0)};

  transition: opacity 200ms ease;
`;

export const StyledDragIcon = styled.div`
  position: absolute;
  left: 4px;
  margin-top: auto;
  display: none;
`;

export const StyledBox = styled.div<
  Partial<{
    isActive: boolean;
    isHighlighted: boolean;
    showError: boolean;
    disabled: boolean;
  }>
>`
  display: flex;
  position: relative;
  align-items: center;
  width: 350px;
  height: 82px;
  background-color: ${Colors.custom1};
  box-sizing: border-box;
  border: ${(props) =>
    props.isActive === true
      ? `2px solid ${SolutionColorVariables.sc1}`
      : "2px solid transparent"};
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 30, 0.1), 0 2px 4px rgba(0, 0, 30, 0.1);
  padding: 17px;
  margin-bottom: 10px;

  transition: all 250ms ease-in-out;

  cursor: ${(props) => (props.disabled === true ? "default" : "pointer")};
  opacity: ${(props) => (props.disabled === true ? "0.3" : "1")};

  .trigger-title-text {
    color: ${(props) =>
      props.showError === true ? Colors.bRed : TextColorNames.tertiary};
  }

  .action-title-text {
    color: ${(props) =>
      props.showError === true ? Colors.bRed : TextColorNames.tertiary};
  }

  .title-application {
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
  }

  .arrow-icon-wrapper {
    opacity: 0;

    transition: opacity 200ms ease;
  }

  &:hover {
    box-shadow: rgb(0 0 0 / 15%) 0 4px 12px 0;

    .trigger-title-text,
    .action-title-text {
      color: ${(props) =>
        props.showError === true ? Colors.bRed : TextColorNames.primary};
    }

    .action-description:not(.disabled),
    .trigger-description:not(.disabled) {
      color: ${SolutionColorVariables.sc1};
      text-overflow: ellipsis;
    }

    .trigger-title-application {
      text-overflow: ellipsis;
    }

    ${StyledDotWrapper} {
      opacity: 1;
    }

    ${StyledDragIcon} {
      visibility: visible;
    }

    .arrow-icon-wrapper {
      opacity: 1;
    }
  }
`;

export const StyledIconWrapper = styled.div`
  width: 38px;
  min-width: 38px;
  height: 38px;
  border: 1px solid #e9e9e9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;
  &.find-records {
    background: ${Colors.dwYellow};
    border: 1px solid rgba(255, 185, 56, 0.2);
  }
  &.merge-records {
    background: ${Colors.dwBlue};
    border: 1px solid rgba(58, 134, 255, 0.2);
  }
`;
